<template>
    <div class="card card-dark border-dark mb-4">
        <div class="card-body">
            <div class="row text-center text-lg-left">
                <div v-for="item in items" class="col-lg-4 col-md-6 col-xs-12">
                    <a :href="item.url" class="d-block mb-4 h-100"
                       data-toggle="lightbox"
                       data-gallery="video-gallery">
                        <figure class="figure">
                            <div class="video-img-wrapper">
                                <img class="figure-img img-fluid rounded" :src="item.thumb" alt="">
                            </div>
                            <figcaption v-if="item.capt" class="figure-caption">{{ item.capt }}</figcaption>
                        </figure>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import 'ekko-lightbox'

    export default {
        data() {
            return {
                items: []
            }
        },
        created() {
            this.loadItems()
        },
        mounted() {
            $(this.$el).on('click', '[data-toggle="lightbox"]', function (event) {
                event.preventDefault();
                $(this).ekkoLightbox();
            })
        },
        methods: {
            loadItems() {
                axios.get('/api/video')
                    .then(response => this.items = response.data.data)
                    .catch(error => console.error(error))
            }
        }
    }
</script>

<style lang="scss">
    @import "~ekko-lightbox/dist/ekko-lightbox.css";

    [data-toggle="lightbox"][data-gallery="video-gallery"] {
        .video-img-wrapper {
            position: relative;
            margin-bottom: 0.5rem;
            > img {
                margin: 0 !important;
            }
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.5);
                opacity: 0;
                transition: .2s opacity ease-in-out;
            }
        }
        &:hover .video-img-wrapper::before {
            opacity: 0.5;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/VideoGallery.vue